'use client';
import { sourceSubscribeCTA } from 'constants/constants'; // TODO: @James - move to app router
import type { ReactNode } from 'react';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import { useAsPath } from '@/app_lib/hooks/useAsPath';
import { ContentPlacement } from '@/app_lib/types/analytics';

export const SubscribeButton = ({ children }: { children: ReactNode }) => {
  const trackingData = {
    data: {
      // biome-ignore lint/style/useNamingConvention: <external data>
      contentPlacementCD: 'header',
      eventAction: 'top header links',
      eventCategory: 'navigation',
      eventLabel: 'subscribe now',
      loggedIn: false, // TODO: replace with actual logged in status when correctly built
    },
  };

  const asPath = useAsPath();

  return (
    <ButtonV2
      aria-label='Subscribe Now to Fortune Magazine'
      data-cy={ContentPlacement.SubscribeButton}
      href={`/subscribe/?itm_source=${sourceSubscribeCTA}&redirect=${encodeURIComponent(asPath)}`}
      trackingData={trackingData}
      variant='accent'
    >
      {children}
    </ButtonV2>
  );
};
